import { useState } from "react";
import Logo from "./assets/logo.png";
import { Link } from "react-router-dom";
import { IoMdArrowDropdown } from "react-icons/io";
import { useSettings } from "../hooks/useSettings";
import NavMenu from "./NavMenu";

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [activeNav, setActiveNav] = useState(""); // Add this line
  const { settings } = useSettings();
  const footerDisclosurePrefix =
    "Information obtained from MLS, public records, and other sources is believed to be correct but not warranted.";
  const footerAssociationDisclosure =
    settings?.footerAssociationDisclosure?.trim() ||
    `This is not the official website of ${settings?.clubName || "this community"}.`;
  const toggleDropdown = (menu) => {
    setActiveDropdown((prevMenu) => (prevMenu === menu ? null : menu));
  };

  const handleMouseLeave = () => {
    setActiveDropdown(null);
  };
  return (
    <footer className="bg-[#BA1500] text-white text-sm font-semibold flex md:flex-col justify-start items-start lg:justify-center lg:items-center w-full">
      <div className="container lg:mx-auto lg:px-4 lg:py-6">
        <div className="flex flex-col md:flex-row justify-between gap-6 pl-5 lg:pl-0">
          <div className="flex flex-col justify-start items-start lg:items-center">
            <Link to="/">
              <h4 className="font-bold text-lg">
                American Realty Network LLC.
              </h4>
            </Link>
            <Link to="/">
              <img
                src={settings?.logoUrl || settings?.logoPath || Logo}
                alt="Logo"
                className="h-16 w-16"
              />
            </Link>
            {settings?.websiteUrl && (() => {
              const raw = settings.websiteUrl.replace(/^https?:\/\//, "").replace(/^www\./i, "");
              const href = `https://www.${raw.toLowerCase()}`;
              const display = settings.websiteDisplayUrl || `www.${raw}`;
              return (
                <a
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="mt-2 text-white hover:underline font-semibold"
                >
                  {display}
                </a>
              );
            })()}
            <p className="mt-2">433 Plaza Real, Suite 275</p>
            <p>Boca Raton, FL 33432</p>
          </div>
          <div className="lg:justify-items-center">
            <p className="font-semibold">Contact Information: </p>
            <p className="mt-2">
              <span className="font-semibold">Phone:</span>{" "}
              {settings?.phoneNumber || "+1 561-702-3795"}
            </p>
            <p>
              <span className="font-semibold">Email:</span>{" "}
              <a
                href={`mailto:${settings?.email || "info@community.com"
                  }`}
                className="hover:underline font-semibold"
              >
                {settings?.email || "info@community.com"}
              </a>
            </p>
          </div>

          <div className="justify-start items-start lg:text-center md:text-right lg:justify-items-center">
            <div className="block">
              <NavMenu
                navItems={settings?.navItems}
                activeNav={activeNav} // Pass activeNav
                setActiveNav={setActiveNav} // Pass setActiveNav
                activeDropdown={activeDropdown}
                setActiveDropdown={setActiveDropdown}
                handleMouseLeave={handleMouseLeave}
                toggleDropdown={toggleDropdown}
                isMenuOpen={true}
                className={""}
                hover={"hover:underline"}
                py={"py-1"}
                dropdownItemClass={"text-[#BA1500] uppercase"}
                displayClass={"flex flex-col"}
              />
            </div>
            <Link to="/Terms-Of-Use" className="hover:underline block py-1">
              TERMS OF USE
            </Link>
            <Link to="/Privacy-Policy" className="hover:underline block py-1">
              PRIVACY POLICY
            </Link>
          </div>
        </div>

        <div className="border-t border-white mt-4 pt-4 text-center text-xs">
          <p>
            {footerDisclosurePrefix} {footerAssociationDisclosure}
          </p>
          <p className="mt-2">
            &copy; {currentYear} American Realty Network LLC. All Rights
            Reserved
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
